import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import * as userModule from 'modules/user';
import { PropTypes } from 'helpers/react';
const { func, string } = PropTypes;

import { Container, Row, Col } from 'shared-components/grid';
import ProfileEntryForm from './ProfileEntryForm';
import styles from '../styles/page';

@connect(
  state => {
    const user = userModule.selectUser(state);
    const firstName = get(user, 'kvp.firstName', '');
    const lastName = get(user, 'kvp.lastName', '');
    return {
      userFullName: `${firstName} ${lastName}`,
      userAccountName: user.userName
    };
  },
  {
    setOnboardingProfileFields: userModule.setOnboardingProfileFields,
    setBasicUserProfile: userModule.setBasicUserProfile
  }
)
export default class ProfileEntryPage extends React.Component {
  static propTypes = {
    setOnboardingProfileFields: func.isRequired,
    userFullName: string,
    userAccountName: string
  };
  static defaultProps = {};

  getUserDetailsFormValues = values => ({
    FirstName: values.firstName ? values.firstName : '',
    LastName: values.lastName ? values.lastName : '',
    Phone: values.phoneNumber ? values.phoneNumber : '',
    Company: values.companyName ? values.companyName : '',
    Website: values.companyUrl ? values.companyUrl : '',
    Street: `${values.companyAddress
      ? values.companyAddress
      : ''} ${values.companySuiteApt ? values.companySuiteApt : ''}`,
    City: `${values.companyCity ? values.companyCity : ''}`,
    State: `${values.companyState ? values.companyState : ''}`,
    PostalCode: `${values.companyZipCode ? values.companyZipCode : ''}`,
    companyCountry: `${values.companyCountry ? values.companyCountry : ''}`,
    Description: `${values.companyDescription
      ? values.companyDescription
      : ''}`,
    User_Program_Details: `Early Adopter Program: ${values.earlyAdopterProgram
      ? values.earlyAdopterProgram
      : ''} \n Use Case: ${values.useCase
      ? values.useCase
      : ''} \n Referred By: ${values.referredBy ? values.referredBy : ''}`
  });

  submit = async values => {
    const {
      setBasicUserProfile,
      setOnboardingProfileFields,
      userAccountName
    } = this.props;
    const userProfileUpdateResult = await setBasicUserProfile(values);
    if (userProfileUpdateResult.type.includes('SUCCESS')) {
      await setOnboardingProfileFields(values);
      const userDetailsFormValues = this.getUserDetailsFormValues(values);
      window.analytics.identify(userAccountName, userDetailsFormValues, {
        integrations: { Salesforce: true }
      });
    }
  };

  render() {
    return (
      <Container topBarOffset sideBarOffset>
        <Row>
          <Col lg={12}>
            <div className={styles['header']}>
              <h2>Tell us about yourself</h2>
              <p>
                Help us help you. Share some details about your organization and
                goals.
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <div className={styles['userName']}>
              <h2>
                {this.props.userFullName}
              </h2>
              <p>
                {this.props.userAccountName}
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <ProfileEntryForm onSubmit={this.submit} />
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/onboarding/pages/profile-entry/components/ProfileEntryPage.js